import { render, staticRenderFns } from "./userReal.vue?vue&type=template&id=4e64a754&scoped=true&"
import script from "./userReal.vue?vue&type=script&lang=js&"
export * from "./userReal.vue?vue&type=script&lang=js&"
import style0 from "./userReal.vue?vue&type=style&index=0&id=4e64a754&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e64a754",
  null
  
)

export default component.exports